import React from 'react';

export const NotFound = () => {
	return (
		<div className='mt-5'>
			<h4 className='text-center pt-5'>404 | This page does not exist</h4>
		</div>
	);
};
